import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { SafeHTMLPipeModule } from "app/shared/pipes/safeHtml";
import { ParentGuardianDialogComponent } from "./parentguardian-dialog.component";
import { ParentGuardianDialogService } from "./parentguardian-dialog.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,

        SafeHTMLPipeModule,
    ],

    declarations: [ParentGuardianDialogComponent],
    exports: [ParentGuardianDialogComponent],
    providers: [ParentGuardianDialogService],
})
export class ParentGuardianDialogModule { }